import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const InfoIcon = (props: IconProps) => (
  <Icon width="24px" height="24px" viewBox="0 0 24 24" {...props}>
    <path d="M11.04 7h2v2h-2V7Zm0 4h2v6h-2v-6Zm1-9c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10Zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8Z" />
  </Icon>
);

export default memo(InfoIcon);
